'use strict';

/* 
 * Ad ogni richista push nel map interceptorConfig, la coppia chiave-valore: config, sendErrors.
 * Ad ogni response la elimino, e in caso di errore, mi posso leggere il valore sendErrors.
 */
module.exports = ['$rootScope', '$q', function ($rootScope, $q) {
        
        //contiene oggetti del tipo { key: _config, sendErrors: bool }
        var interceptorConfig = [];
        
        // rimuove una key da interceptorConfig, e restituisce il relativo campo sendErrors
        function handleInterceptorConfig(response) {
            var result = true;
            for (var i in interceptorConfig) {
                if (interceptorConfig[i].key === response.config) {                    
                    result = interceptorConfig[i].sendErrors;
                    interceptorConfig.splice(i, 1);
                    break;
                }
            }
            return result;
        }

        this.request = function (_config) {
            _config.ts = new Date().getTime();
            var config = {
                key: _config,
                sendErrors: angular.isDefined(_config.sendErrors) ? _config.sendErrors : true
            };
            interceptorConfig.push(config);
            return _config;
        };

        this.response = function (response) {
            handleInterceptorConfig(response);
            return response || $q.when(response);
        };

        this.responseError = function (rejection) {
            if (handleInterceptorConfig(rejection) !== false) {
                switch (rejection.status) {
                    case 401:
                        $rootScope.$emit('ngDroError401', rejection);
                        break;
                    case 403:
                        $rootScope.$emit('ngDroError403', rejection);
                        break;
                    default:
                        $rootScope.$emit('ngDroServerError', rejection);
                }
            }
            return $q.reject(rejection);
        };

        // API
        return {
            response: this.response,
            responseError: this.responseError,
            request: this.request
        };
    }];







//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/services/error/ErrorInterceptor.js
// module id = 389
// module chunks = 0